import { marginRight, typography } from "../../../styles";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
export const LineItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  ${typography.small};
  color: ${({
  theme
}) => theme.brand.cssVars["--d-muted"]};
`;
export const Label = styled.div`
  &::first-letter {
    text-transform: capitalize;
  }

  > *:not(:last-child) {
    ${marginRight.s}
  }
`;
export const Value = styled.div`
  ${marginRight.s}
  ${typography.smallBold}
`;
export const XIcon = styled(FontAwesomeIcon).attrs({
  icon: faTimes
})`
  color: ${({
  theme
}) => theme.brand.cssVars["--d-text"]};
`;